module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-consultation-thank-you"
  }, [_vm._m(0), _c('div', {
    staticClass: "pages-consultation-thank-you__socials"
  }, [_c('a', {
    staticClass: "pages-consultation-thank-you__facebook",
    attrs: {
      "href": "https://www.facebook.com/starsmilesorthopedo"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "fb"
    }
  })], 1), _c('a', {
    staticClass: "pages-consultation-thank-you__instagram",
    attrs: {
      "href": "https://www.instagram.com/starsmilesorthopedo/?ref=badge"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "ig"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-consultation-thank-you__thank-you"
  }, [_c('h1', [_vm._v("Thank you for submitting your request!")]), _c('div', {
    staticClass: "pages-consultation-thank-you__text"
  }, [_vm._v("One of our team members will reach out to you as soon as possible to schedule a time that is convenient for you! In the meantime please feel free to get to know us a little more by visiting our social media channels.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19f4c37a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/consultation-thank-you/consultation-thank-you.pug
// module id = 665
// module chunks = 1